import { useQuery } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { getRevisionMerchantOverrides } from 'Services';
import { RQ_RULE_REVISION_MERCHANT_OVERRIDES } from 'Utils';

const useGetMerchantOverrides = () => {
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery([RQ_RULE_REVISION_MERCHANT_OVERRIDES], () => getRevisionMerchantOverrides(templateRepositoryId!), {
        enabled: !!(templateRepositoryId && templateRepositoryId > 0)
    });
};

export default useGetMerchantOverrides;
